module.exports = __webpack_public_path__ + "assets/img/station21.21475129.png";